<template>
  <div>
    <div class="xyList">
      <div class="xyBox" v-for="item in evaluateVoList" :key="item.id">
        <div class="headXy">
          <div style="display: flex">
            <div>
              <img class="headImg" :src="item.userPhoto" alt="安徽继续教育网" />
            </div>
            <div style="margin-left: 10px">
              <div class="e1">{{ item.userName }}</div>
              <div class="e2">{{ item.createTime }}</div>
            </div>
          </div>

          <div class="rightns">购买过{{ item.className }}</div>
        </div>

        <div class="plnr">
          {{ item.content }}
        </div>
      </div>
    
    

      <div style="display: flex; justify-content: center; width: 1400px">
        <div class="btnShop" @click="goXk">
          <div>我也要购买课程</div>
          <div style="margin-left: 4px;"><img src="../../assets/indexImg/jt.png" alt="安徽继续教育网" /></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  props:['evaluateVoList'],
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {};
  },
 
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    goXk() {
      this.$router.push({
        path: '/lsitFs',
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log(this.evaluateVoList,'evaluateVoList');
    
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.xyList {
  position: relative;
  z-index: 2;
  display: flex;
  flex-wrap: wrap;
  .xyBox {
    width: 450px;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
    padding: 20px;
    margin-right: 25px;
    margin-bottom: 20px;
    .headXy {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .headImg {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
      .e1 {
        font-weight: 500;
        font-size: 16px;
        color: #4076f6;
      }
      .e2 {
        font-weight: 400;
        font-size: 12px;
        color: #999999;
      }
      .rightns {
        height: 28px;
        background: rgba(255, 136, 51, 0.1);
        border-radius: 6px 6px 6px 6px;
        color: #ff8833;
        text-align: center;
        line-height: 28px;
        font-size: 12px;
        padding: 0 10px;
      }
    }
    .plnr {
      margin-top: 12px;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }
  }
  .btnShop {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-top: 20px;
    text-align: center;
    color: #4076f6;
    font-size: 16px;
    font-weight: 500;
    width: 200px;
    height: 48px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid;
    border-image: linear-gradient(97deg, rgba(149, 181, 255, 1), rgba(64, 147, 246, 1)) 1 1;
  }
  .xyBox:nth-child(3n) {
    margin-right: 0 !important;
  }
}
</style>
